import React from 'react';

class Finished extends React.Component {

    // constructor(props) {
    //     super(props);
    // }

    render() {
        return (
            <div>
                <img src="img/texture1.png" className="backgroundfill" alt=""/>
                <div className="side-menu ">
                    <div className="cover"></div>
                    <div className="step-menu-con">
                        <img src="img/sid-menu-img.png" alt="exsample gif" srcSet="" className="side-menu-top"/>
                        <div className="center-gold"></div>
                        <h1 >thank you lord</h1>
                        <h3>enhanced video</h3>

                        <div className="textcon">
                            <p>Join Chris Tomlin, Thomas Rhett, and Florida Georgia Line in a :25 clip from “Thank You Lord”!</p>
                            <div className="center-gold"></div>
                        </div>

                        <div className="listcon">
                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber"><img className="stepimg check" src="img\check.svg" alt=""/></div>
                                </div>
                                <h2 className="step-title">tell us what you’re thankful for</h2>
                            </div>

                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber"><img className="stepimg check" src="img\check.svg" alt=""/></div>
                                </div>
                                <h2 className="step-title"> Show what you are thankful for</h2>
                            </div>

                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber"><img className="stepimg check" src="img\check.svg" alt=""/></div>
                                </div>
                                <h2 className="step-title"> get your custom music video!</h2>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div className="body-con">
                    <br/>

                    <div className="current-step">
                        <div className="line-before"></div>
                        <div className="con step-con">
                            <div className="step">
                                <img className="stepimg" src="img/mail.svg" alt=""/>
                            </div>
                        </div>
                        <div className="line-after"></div>
                    </div>

                    <h1 className="main-color">that’s it! your video should be done shortly! </h1>

                    <div className="textcon smalltext-con">
                        <p>Check your email; we’ll send your video there when it’s finished.<span className="hidden-mobile">While you wait, check out the other singles from Chris Tomlin’s new album: Chris&nbsp;Tomlin&nbsp;&&nbsp;Friends </span></p>
                    </div>
                    <div className="end-playlist-con">
                        <img src="img/album.png" srcSet="" className="album-image2" alt=""/>

                        <div className="textcon deskhidden">
                            <p>While you wait, check out the other singles from Chris Tomlin’s new album: Chris&nbsp;Tomlin&nbsp;&&nbsp;Friends </p> <br/>
                        </div>

                        <div className="playlist-con">

                            <div className="textcon w90">
                                <h3> WATCH ON YOUTUBE </h3>
                                <div className="full_line"></div>
                            </div>

                            <div className="videolist">
                                <a href="https://www.youtube.com/watch?v=Wlkl4EQpQhA" 
                                    data-amplify-analytics-on='click'
                                    data-amplify-analytics-name='click'
                                    data-amplify-analytics-attrs='attr:Youtube-ThankYouLordAudio'>
                                    <div className="vid-thumb">
                                        <div className="con vidcon">
                                            <img src="img/vid-1.png" className="vid-img" alt=""/>
                                            <div className="play-button-thumb"></div>
                                        </div>

                                        <div className="song-title-thumb"> Thank You Lord (Audio)</div>
                                        <div className="song-artist-thumb"> feat. Thomas Rhett, Florida Georgia Line</div>
                                    </div>
                                </a>

                                <div className="full_line"></div>
                                <a href="https://www.youtube.com/watch?v=wms76AfllVE" 
                                    data-amplify-analytics-on='click'
                                    data-amplify-analytics-name='click'
                                    data-amplify-analytics-attrs='attr:Youtube-WhoYouAreToMeLyric'>
                                    <div className="vid-thumb">
                                        <div className="con vidcon">
                                            <img src="img/vid-2.png" className="vid-img" alt=""/>
                                            <div className="play-button-thumb"></div>
                                        </div>

                                        <div className="song-title-thumb"> Who You Are to Me (Lyric Video)</div>
                                        <div className="song-artist-thumb"> feat. Lady A </div>
                                    </div>
                                </a>

                                <div className="full_line"></div>
                                <a href="https://youtu.be/Sejv8a-vCyc" 
                                    data-amplify-analytics-on='click'
                                    data-amplify-analytics-name='click'
                                    data-amplify-analytics-attrs='attr:Youtube-BeTheMoon'>
                                    <div className="vid-thumb">
                                        <div className="con vidcon">
                                            <img src="img/vid-1.png" className="vid-img" alt=""/>
                                            <div className="play-button-thumb"></div>
                                        </div>

                                        <div className="song-title-thumb"> Be The Moon (lyric video)</div>
                                        <div className="song-artist-thumb"> feat. Brett Young, Cassadee Pope</div>
                                    </div>
                                </a>

                                <div className="full_line"></div>
                                <a href="https://www.youtube.com/watch?v=TSCOyar70UY"
                                    data-amplify-analytics-on='click'
                                    data-amplify-analytics-name='click'
                                    data-amplify-analytics-attrs='attr:Youtube-WhoYouAreToMeStory'>
                                    <div className="vid-thumb">
                                        <div className="con vidcon">
                                            <img src="img/vid-4.png" className="vid-img" alt=""/>
                                            <div className="play-button-thumb"></div>
                                        </div>
                                        <div className="song-title-thumb"> Who You Are To Me (The Story)</div>
                                        <div className="song-artist-thumb"> feat. Lady A </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <br/>
                    <div className="next-button-con ">
                        <div className="line-before"></div>
                        <div className="congratz hidden-mobile">thanks for participating!</div>
                        <div className="line-after"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Finished;